<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedit">For my grandfather, Frederick Arthur Lee, whose perseverance, wit and legacy lives on in me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM01.vue?d09b4678